import {Thumbs, Navigation, Pagination, Controller, Keyboard} from 'swiper/modules';
import {Swiper} from 'swiper';

export class ProductImagesMain {
	static sliders = [];

	private element: HTMLElement;
	private readonly sliderElement: HTMLElement;
	private readonly buttonPrev: HTMLButtonElement;
	private readonly buttonNext: HTMLButtonElement;
	private readonly paginationElement: HTMLElement;
	private readonly thumbs: Swiper;
	private sliderSettings = () => ({
		modules: [Thumbs, Navigation, Pagination, Controller, Keyboard],
		loop: true,
		slidesPerView: 1,
		navigation: {
			prevEl: this.buttonPrev,
			nextEl: this.buttonNext,
		},
		pagination: {
			el: this.paginationElement,
			bulletClass: 'product-images-main__bullet',
			bulletActiveClass: 'product-images-main__bullet--active',
		},
		thumbs: {
			swiper: this.thumbs,
		},
		keyboard: {
			enabled: Boolean(this.element.closest('.product-images-modal')),
			onlyInViewport: true,
		},
		on: {
			init: (swiper) => {
				if (swiper.slides[0].classList.contains('product-images-main__slide--video')) swiper.slideTo(1, 0);
			},
		}
	});
	public slider: Swiper;

	constructor(element, thumbs) {
		if (!element) return;
		this.element = element;
		this.thumbs = thumbs;
		this.sliderElement = this.element.querySelector('.product-images-main__slider');
		this.paginationElement = this.element.querySelector('.product-images-main__pagination');
		this.buttonPrev = this.element.querySelector('.product-images-main__button--prev');
		this.buttonNext = this.element.querySelector('.product-images-main__button--next');

		this.init();
	}

	public init = ():void => {
		this.slider = new Swiper(this.sliderElement, this.sliderSettings());
		ProductImagesMain.sliders.forEach((slider) => this.slider.controller.control = slider);
		ProductImagesMain.sliders.forEach((slider) => slider.controller.control = this.slider);
		ProductImagesMain.sliders.push(this.slider);
	};
}
